module.exports = __webpack_public_path__ + "img/night-by-nasa.88f56602.jpg";